import React, { useContext, useEffect, useState } from 'react'
import studyReportContext from '../../../../context/studyreport/StudyReportContext';
import { useTranslation } from 'react-i18next';
import ManageAdvKeyImagePreview from './ManageAdvKeyImagePreview';
import { Checkbox, Icon, TextField, TooltipHost } from '@fluentui/react';
import Save from '../../../../components/SVGComponents/KeyImage/Save';
import Revert from '../../../../components/SVGComponents/KeyImage/Revert';
import Clear from '../../../../components/SVGComponents/KeyImage/Clear';
import Edit from '../../../../components/SVGComponents/KeyImage/Edit';
import { useFormik } from 'formik';
import { KeyImageSchema } from '../../../../Schemas/KeyImageSchema';
import ATextField from '../../../../components/ATextField';
import { _getAdvKeyImageForPreview } from '../../../../service/StudyViewerService';
import { AdvKeyImageSchema } from '../../../../Schemas/AdvKeyImageSchema';
import { USERTYPES } from '../../../../constants/Constants';
import CustomToolTipHost from '../../../../components/CustomToolTipHost/CustomToolTipHost';

const AdvKeyImageRow = (props) => {

    const [isEditable, setIsEditable] = useState(false);
    const [previewAdvKeyImage, setPreviewAdvKeyImage] = useState(false);
    const [previewKeyImageId, setPreviewKeyImageId ] = useState("");

    let advKeyImageData = props.advKeyImagesData;

    const {
        setAlertSuccessModal,
        alertSuccessModal
      } = useContext(studyReportContext);

    const keyImage = props.keyImage;
    const imageTitle = keyImage.title;
    const { t } = useTranslation();

    useEffect(()=>{
        advKeyImageData = [];
        for(let index in props.advKeyImagesData){
            let obj = {...props.advKeyImagesData[index]};
            advKeyImageData.push(obj);
        }
        console.log("templist---advKeyImageData---", advKeyImageData);
    },[props.advKeyImagesData]);

    const {
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        resetForm,
      } = useFormik({
        enableReinitialize: true,
        initialValues: { imageTitle },
        validationSchema: AdvKeyImageSchema,
        onSubmit: async (values, action) => {
            if (isKeyImageTitleAlreadyPresent(values.imageTitle)) {
                console.log("is key submitted")
                setAlertSuccessModal(()=>{
                const newItem = {...alertSuccessModal};
                newItem.show = true;
                newItem.heading = "Alert";
                newItem.isError = false;
                newItem.isSuccess = false;
                newItem.isWarning = true;
                newItem.description = t("key-image.title-already-exists");
                return newItem;
                });
                action.resetForm();
                return;
            }
            console.log(props.index, advKeyImageData);
            advKeyImageData[props.index].title=values.imageTitle;
            props.setAdvKeyImagesData(advKeyImageData);
            setIsEditable(false);
            action.resetForm();
        },
    });

    const handleSaveTool = () =>{
        handleSubmit();
    }

    const handleResetTool = () =>{
        resetForm();
    }

    const handleClearTool = () =>{
        setIsEditable(false);
    }

    const handleKeyImageCheckBox = (imageId, index, event) =>{
        // event.preventDefault();
        let isChecked = event.target.checked;
        // No 6-image cap: the enabled flag is the single, uncapped "in report or not" source
        // shared with the captured-images popup (matches KeyImageService validation).
        let tempList = [];
        for(let index in props.advKeyImagesData){
            let keyimage = props.advKeyImagesData[index];
            let obj  = {...keyimage};
            tempList.push(obj);
        }
        tempList[index].enabled=isChecked;
        props.setAdvKeyImagesData(tempList);
    }

    const isKeyImageTitleAlreadyPresent = (keyTitle) => {
        for(let index in advKeyImageData){
            if (index != props.index && advKeyImageData[index].title === keyTitle) {
                return true;
            }
        }
        return false;
    };


  return (
    <>
        {previewAdvKeyImage && 
        <ManageAdvKeyImagePreview
            previewAdvKeyImage={previewAdvKeyImage}
            setPreviewAdvKeyImage={setPreviewAdvKeyImage}
            studyId={props.studyId}
            imageId={previewKeyImageId}
        />
        }
            <div id={keyImage.imageId}
                style={{
                width: "97%",
                display: "flex",
                alignItems: "center",
                backgroundColor: "#262525",
                borderRadius: "10px",
                padding: "5px 0px",
                // height: "60px",
                marginTop: "10px",
                cursor:"pointer"
                }}
            >
                <div id={keyImage.imageId + "_title"} style={{ width: "60%",display:"flex" }}>
                {isEditable ? (
                    <>
                    <div style={{ width: "80%", marginLeft: "10px" }}>
                    <CustomToolTipHost
                        content={t("key-image.image-title")}
                        id="key-images"
                     >
                        <ATextField
                            name="imageTitle"
                            onChange={handleChange}
                            value={values.imageTitle}
                            onBlur={handleBlur}
                            errorMessage={touched.imageTitle && errors.imageTitle}
                        />
                        </CustomToolTipHost>
                    </div>
                    </>
                ) : (<CustomToolTipHost
                        content={t("key-image.image-title")}
                        id="key-images"
                     >
                        <span style={{ color: "#FFFFFF", padding: "0px 5px 0px 10px",display:"flex" }}>
                        {keyImage?.title}
                        </span>
                    </CustomToolTipHost>
                )}
                </div>
                <div style={{ width: "25%", display: "flex", alignItems: "center" }} key={props.index}>
                {isEditable ? (
                    <>
                    <div key={keyImage.imageId + "_save"} automation-id="save_key_image" style={{ marginRight: "10px",display: "flex", alignItems: "center" }} onClick={()=>handleSaveTool()}>
                    <CustomToolTipHost
                        content={t("key-image.save")}
                        id="key-images"
                    ><Save /></CustomToolTipHost>
                    </div>
                    <div key={keyImage.imageId + "_revert"} style={{ marginRight: "10px",display: "flex", alignItems: "center" }} onClick={()=>handleResetTool()}>
                    <CustomToolTipHost
                        content={t("key-image.reset")}
                        id="key-images"
                        ><Revert /></CustomToolTipHost>
                    </div>
                    <div key={keyImage.imageId + "_clear"}
                        style={{ marginRight: "10px",display: "flex", alignItems: "center" }}
                        onClick={() => {
                        handleClearTool()
                        }}
                                        >
                        <CustomToolTipHost
                            content={t("key-image.cancel")}
                            id="key-images"
                        ><Clear /></CustomToolTipHost>
                    </div>
                    </>
                ) : (
                    <>{props.roles.length > 0 && (props.roles[0].includes(USERTYPES.SUPERVISOR) || props.roles[0].includes(USERTYPES.RADIOLOGIST)) &&
                    <div key={keyImage.imageId + "_edit"} id={keyImage.imageId + "_edit"} style={{ display: "flex", alignItems: "center" }} onClick={() => setIsEditable(true)}>
                    <CustomToolTipHost
                        content={t("key-image.edit")}
                        id="key-images"
                     ><Edit />{" "}</CustomToolTipHost>
                    </div>
                    }
                    </>
                )}
                </div>
                <div
                style={{ width: "10%", display: "flex" }}
                onClick={() => {
                    // previewAdvKeyImageFunc(keyImage.imageId);
                    setPreviewAdvKeyImage(true);setPreviewKeyImageId(keyImage.imageId);
                }}
                >
                <CustomToolTipHost
                        content={t("key-image.preview-key-image")}
                        id="key-images"
                    ><Icon
                    style={{color:'#C1C1C1'}}
                    iconName={"FilePDB"}></Icon>
                </CustomToolTipHost>
                </div>
                <div
                style={{ width: "10%", display: "flex" }}
                ><CustomToolTipHost
                        content={t("key-image.key-image-enabled")}
                        id="key-images"
                     >
                    <Checkbox
                        style={{
                        fontWeight: "400",
                        }}
                        checked={props.keyImage.enabled}
                        onChange={(e)=>handleKeyImageCheckBox(keyImage.imageId, props.index, e)}
                        boxSide="start"
                        inputProps={{ 'aria-label': 'controlled' }}
                        disabled={props.roles.length > 0 && !(props.roles[0].includes(USERTYPES.SUPERVISOR) || props.roles[0].includes(USERTYPES.RADIOLOGIST))}
                    />
                    </CustomToolTipHost>
                </div>
            </div>
        </>
  )
}

export default AdvKeyImageRow